/* eslint-disable no-console */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { analytics } from "@kaggle/protos";
import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";
var ANALYTICS_ENDPOINT_URL = "https://analytics.kaggle.io/record-events";
/** The logic to encode the queues events and flush them to relay. */ export var prodFlushEventQueue = function() {
    var _ref = _asyncToGenerator(function(queue, info, token, pageUnloading) {
        var batch, body, response, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Bypass sending events if none are enqueued.
                    if (queue.length === 0) {
                        return [
                            2,
                            200
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    batch = makeEventBatch(queue, info, token);
                    body = analytics.kaggle.analytics.SaveClientAnalyticsRequest.encode(batch).finish();
                    // If we're about to lose the window, and the Beacon API is available, use
                    // sendBeacon and ignore any result since we don't expect a response.
                    // @ts-ignore TS thinks navigator.sendBeacon will always be true, but it is
                    // subject to browser compatibility. https://caniuse.com/?search=beacon
                    if (pageUnloading && navigator.sendBeacon) {
                        navigator.sendBeacon(ANALYTICS_ENDPOINT_URL, body);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        fetch(ANALYTICS_ENDPOINT_URL, {
                            method: "POST",
                            body: body
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.status
                    ];
                case 3:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.warn("An issue occurred flushing the events queue.", err);
                    return [
                        2,
                        500
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function prodFlushEventQueue(queue, info, token, pageUnloading) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Returns a batch of events with additional metadata.
 *
 * @param queue Array of events to be logged.
 * @param sessionInfo Metadata associated with session used to augment
 *    payload containing batch of sessions.
 * @param token Token used for authorization by analytics service.
 */ function makeEventBatch(queue, param, token) {
    var userId = param.userId, pageview = param.pageview;
    return analytics.kaggle.analytics.SaveClientAnalyticsRequest.create({
        url: document.location ? document.location.pathname : "",
        userId: userId,
        // We no longer support kaggleAnalyticsUserHash, this should be removed
        // from the report structure in the future.
        kauh: "",
        session: getAnalyticsSessionCookie(),
        timeZoneOffsetMinutes: new Date().getTimezoneOffset(),
        referrer: document.referrer,
        token: token,
        performanceTier: 1,
        competitionsTier: 1,
        kernelsTier: 1,
        discussionTier: 1,
        windowWidthPixels: window.innerWidth,
        windowHeightPixels: window.innerHeight,
        screenWidthPixels: window.screen.width,
        screenHeightPixels: window.screen.height,
        events: queue,
        pageview: pageview,
        urlQueryString: window.location.search
    });
}
/** Returns unique session identifier stored in browser's Cookies. */ function getAnalyticsSessionCookie() {
    var existingResult = getSessionCookie();
    if (existingResult) {
        return existingResult;
    }
    var newResult = uuidv4();
    setSessionCookie(newResult);
    return newResult;
}
// getSessionCookie returns the session ID if it is present in the user's browser cookies, and
// null otherwise.
function getSessionCookie() {
    return Cookie.get("ka_sessionid");
}
function setSessionCookie(value) {
    // Following go/cookie-guidlines, we use a 6-month expiry for this cookie without an explicit opt-in.
    var seconds = 1000;
    var minutes = 60 * seconds;
    var hours = 60 * minutes;
    var days = 24 * hours;
    var months = 30.4 * days;
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + 6 * months);
    document.cookie = "ka_sessionid=".concat(value, "; expires=").concat(expiryDate.toUTCString(), "; path=/");
}
/** Writes events in queue to console. */ export var consoleFlushEventQueue = function(queue, info, _token, _pageUnloading) {
    if (queue.length > 0) {
        // Print analytics messages in a collapsed group.
        console.groupCollapsed("@kaggle/analytics", "".concat(queue.length, " events"));
        // Print session information.
        console.table([
            info
        ]);
        // Print queue.
        console.table(queue);
        // End group.
        console.groupEnd();
    }
    return Promise.resolve(200);
};
